import router from '../../../../router';
import * as types from './types';
import { HttpClient, MHTTPCL } from '../../../../services/http/http-client';
import { TracksService } from '../../services/tracks.service';
import { getNavTabModule } from '../../../../dt-plugins/sidewindow/nav-tab';
import { setMainNavInactive } from '../../../../store/app/mutations';
import { value } from 'sanctuary';
import { EOL_REACHED } from '../../../../dt-plugins/advanced-search/load.model';


// Action Object for TracksCatalog. Import the types from tracks/types.js and Invoke Actions from the Vuex Host Components.
const NavTabModule = getNavTabModule(types.TrackDetails, 'trackDetails');

export const tracksCatalogActions = {
  async [types.TracksCatalogData.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    const tracksCatalogData = await HttpClient.mergeRequests([

    ]);
    console.log(tracksCatalogData);
    commit(types.TracksCatalogData.SET.ALL, tracksCatalogData);
  },

  async [types.TrackList.FETCH.ALL]({ commit, getters, state }, payload) {
    const { start, row_count, searchMode, basicFilter, searchFilter } = payload;

    let res;

    if (searchMode === 'none') {
      if (start === 0) {
        res = await TracksService.getTracks({ start });
        commit(types.TrackList.SET.ALL, res.data);
      } else {
        res = await TracksService.getTracks({ start });
        commit(types.TrackList.SET.ALL, {
          ...getters.trackList,
          tracks: [
            ...getters.trackList.tracks,
            ...res.data,
          ]
        });

        // Setting EOL
        if (!(res?.data?.length > 0)) {
          return EOL_REACHED;
        }
      }

    } else if (searchMode === 'basic') {
      const { searchString, artist, digital_right, isrc_check } = basicFilter;
      res = await TracksService.searchTracks(searchString, artist, digital_right, isrc_check ? 1 : 0, start);

      if (start === 0) {
        commit(types.TrackList.SET.ALL, {
          ...getters.trackList,
          tracks: res.data
        });
      } else {
        commit(types.TrackList.SET.ALL, {
          ...getters.trackList,
          tracks: [
            ...getters.trackList.tracks,
            ...res.data
          ]
        });
      }
      // if(searchString!=''){
      //   if (start == 0) {
      //     commit(types.TrackList.SET.ALL, {
      //       ...getters.trackList,
      //       tracks: res.data
      //     });
      //   } else {
      //     commit(types.TrackList.SET.ALL, {
      //       ...getters.trackList,
      //       tracks: [
      //         ...getters.trackList.tracks,
      //         ...res.data
      //       ]
      //     });
      //   }
      // }else{
      //   if (start == 0) {
      //     res = await TracksService.getTracks({ start });
      //     commit(types.TrackList.SET.ALL, res.data);
      //   } else {
      //     res = await TracksService.getTracks({ start });
      //     commit(types.TrackList.SET.ALL, {
      //       ...getters.trackList,
      //       tracks: [
      //         ...getters.trackList.tracks,
      //         ...res.data,
      //       ]
      //     });

      //     // Setting EOL
      //     if (!(res?.data?.length > 0)) {
      //       return EOL_REACHED;
      //     }
      //   }
      // }



      // Setting EOL
      if (!(res?.data?.length > 0)) {
        return EOL_REACHED;
      }
    } else if (searchMode == 'advanced') {
      // console.log({ "searchFilter": searchFilter });
      res = await TracksService.fetchAdvancedSearch({ ...searchFilter, offset: start });

      if (start === 0) {
        commit(types.TrackList.SET.ALL, {
          ...getters.trackList,
          tracks: res.data
        });
      } else {
        commit(types.TrackList.SET.ALL, {
          ...getters.trackList,
          tracks: [
            ...getters.trackList.tracks,
            ...res.data
          ]
        });
      }
      // Setting EOL
      if (!(res?.data?.length > 0)) {
        return EOL_REACHED;
      }
    }
  },

  async [types.TrackList.SET.ALL]({ commit, getters }, payload) {
    commit(types.TrackList.SET.ALL, {
      ...getters.trackList,
      tracks: payload
    });
  },

  // Advanced Search
  // async [types.ADVANCED_SEARCH_CONFIG] ({ commit, getters}, payload) {
  //   const res = await TracksService.tracksAdvancedSearch(payload);

  //   console.log('Advance search date ... ', res.data);
  // searchConfig
  // commit(types.TrackList.SET.ALL, {
  //   ...getters.TrackList,
  //   tracks: res.data
  // });
  // state.track_list_start_from = offset || 0;
  // }

  async [types.TrackDetails.FETCH.SINGLE]({ commit, getters, dispatch }, payload = {}) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    let { flag, track, reload } = payload;

    flag = typeof flag === 'boolean' ? flag : true;

    setMainNavInactive(commit, flag);

    const primaryKey = 'track_id';
    const itemName = 'track';
    const item = payload[itemName];

    if (!item) {
      return;
    }

    const primaryKeyValue = item[primaryKey];
    const detailsGetterKey = 'trackDetails';
    const DetailsAction = types.TrackDetails;

    // Check Reload and prexisting Item Logic
    if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
      return;
    }

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
      return {
        [itemName]: item,
        loading: true,
      }
    })

    // HTTP Req
    const detailsData = await HttpClient.mergeRequests([
      TracksService.fetchTrackDetails(track.track_id),
      TracksService.fetchTrackDetailsReleaseProductLicensing(track.track_id),
      TracksService.trackDetailsMetadata(track.track_id),
      TracksService.showMetadata(track.track_id),
      TracksService.fetchTrackDetailsSales(track.track_id),
      TracksService.getLabelCopy(track.track_id),
    ]);

    console.log("detailsData", detailsData);

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, (detailsDict, track) => {
      return {
        ...track,
        ...detailsData,
        loading: false,
      }
    })
  },

  // NavItem child details
  ...NavTabModule.implementActions(
    'track_id',
    'tracks/track_id/tab',
    'tracks',
    () => router,
    'catalog',
    (value, key) => {
      // console.log("WWW", value)
      return {
        title: value?.track?.title ? `${value.track.title} ${(value.track.version == "" || value.track.version == null) ? "" : `(${value.track.version})`}` : key,
        full_title: value?.track?.title ? value.track.title : key
      }
    }
  ),

  // Action of Updating single Object
  async [types.TrackDetails.UPDATE.SINGLE]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { name, value, item } = payload;
    const { track } = item;
    const { track_id } = track;

    NavTabHelper.updateSingleNavTabDetails(track_id, (trackObj) => {
      return {
        track: {
          ...trackObj.track,
          [name]: value,
        }
      }
    });

    const table = 'l_tracks';

    const updatedTrackDetailsRes = await MHTTPCL.modifyJSON(
      undefined,
      track_id,
      name,
      value,
      table,
    );
  },

  async [types.SET_MAIN_PRODUCT]({ getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { product, product_info } = payload;
    const track_id = payload.product_info.track_id;

    NavTabHelper.updateSingleNavTabDetails(track_id, (trackObj) => {
      return {
        product,
        product_info
      }
    });
  },

  async [types.TrackCredits.SET.ALL]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    console.log('set payload ', payload);
    const { track_credits, item } = payload;
    const { track } = item;
    const { track_id } = track;


    const reducedArray = track_credits.reduce((accum, cur) => {

      if (accum != {}) {
        const groupKey = `${cur.type}s`;
        if (groupKey in accum) {
          accum = {
            ...accum,
            [groupKey]: [...accum[groupKey], cur]
          }
        } else {
          accum = {
            ...accum,
            [groupKey]: [cur]
          }
        }
      } else {
        accum = {
          [groupKey]: [cur]
        }
      }
      return accum;
    }, {});




    console.log("ACCCUM", reducedArray)

    NavTabHelper.updateSingleNavTabDetails(track_id, (trackObj) => {
      return {
        track_credits,

        arrangers: reducedArray.hasOwnProperty('arrangers') ? [...reducedArray['arrangers']] : [...item.arrangers],
        composers: reducedArray.hasOwnProperty('composers') ? [...reducedArray['composers']] : [...item.composers],
        writers: reducedArray.hasOwnProperty('writers') ? [...reducedArray['writers']] : [...item.writers],
        producers: reducedArray.hasOwnProperty('producers') ? [...reducedArray['producers']] : [...item.producers],
        publishers: reducedArray.hasOwnProperty('publishers') ? [...reducedArray['publishers']] : [...item.publishers],





      }
    });
  },

  // Action of Updating single Object
  async [types.TrackCredits.UPDATE.SINGLE]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { track_id, track_info_id, type, name, percentage } = payload;
    console.log('Track Details state ', getters.trackDetails[track_id].track_credits); // 1865: {track_credits:[], name: 'ad'}, 1866: {}

    NavTabHelper.updateSingleNavTabDetails(track_id, (trackObj) => {
      // console.log('show trackObj', trackObj);
      return {
        track_credits: trackObj.track_credits.map(x => {
          if (x.track_info_id == payload.track_info_id) {
            return {
              ...x, // Old data
              type,
              name,
              percentage,
            }
          } else {
            return x;
          }
        })
      }
    });

    await TracksService.submitTrackCredit(track_id, track_info_id, type, name, percentage);
  },

  async [types.TrackCredits.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const track_id = payload.track_id;
    const track_info_id = payload.item.track_info_id;

    NavTabHelper.updateSingleNavTabDetails(track_id, (trackObj) => {
      return {
        track_credits: trackObj.track_credits.
          filter(e => e.track_info_id != track_info_id)
      }
    });

    await TracksService.removeTrackCredit(track_info_id);
  },

  async [types.TrackAdditionalInfo.SET.ALL]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { track_additionals, item } = payload;
    const { track } = item;
    const { track_id } = track;

    NavTabHelper.updateSingleNavTabDetails(track_id, (trackObj) => {
      return {
        track_additionals,
      }
    });
  },

  async [types.TrackAdditionalInfo.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const track_id = payload.track_id;
    const track_info_id = payload.item.track_info_id;

    NavTabHelper.updateSingleNavTabDetails(track_id, (trackObj) => {
      return {
        track_additionals: trackObj.track_additionals.
          filter(e => e.track_info_id != track_info_id)
      }
    });

    await TracksService.removeTrackCredit(track_info_id);
  },

  // Action of Updating single Object --- Additional Info
  async [types.TrackAdditionalInfo.UPDATE.SINGLE]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { track_id, track_info_id, description, name, percentage } = payload;

    NavTabHelper.updateSingleNavTabDetails(track_id, (trackObj) => {
      return {
        track_additionals: trackObj.track_additionals.map(x => {
          if (x.track_info_id == payload.track_info_id) {
            return {
              ...x, // Old data
              description,
              name,
              percentage,
            }
          } else {
            return x;
          }
        })
      }
    });

    await TracksService.submitTrackCredit(track_id, track_info_id, description, name, percentage);
  },

  async [types.SET_TRACK_PRODUCT_FILES]({ dispatch, getters }, { files, externalId, externalTable }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const track_id = externalId;
    NavTabHelper.setSingleNavTabDetails(track_id, (_, trackDetailsObject) => {
      return {
        ...trackDetailsObject,
        files,
      }
    });
  },

  async [types.TrackGenre.SET.ALL]({ getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { track_genres, track_id } = payload;

    NavTabHelper.updateSingleNavTabDetails(track_id, (trackObj) => {
      return {
        track_genres
      }
    });
  },

  async [types.TrackGenre.UPDATE.SINGLE]({ getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { name, value, item, selectedTrackDetails } = payload;
    const { track } = selectedTrackDetails;
    const { track_id } = track;

    const key = 'genre_relation_id';
    const kVal = item[key];
    const table = 'genre_relations';

    NavTabHelper.updateSingleNavTabDetails(track_id, (trackObj) => { // trackObj --> getters.trackDetails
      // console.log('trackObj ', trackObj);
      return {
        track_genres: trackObj.track_genres.map(e => {
          if (e.genre_relation_id == item.genre_relation_id) {
            return {
              ...e,
              [name]: value,
            };
          } else {
            return e;
          }
        })
      }
    });

    const modifiedTrack = await MHTTPCL.modifyJSON(undefined, kVal, name, value, table);
  },

  // [[getters.trackDeails/trackObj] + computed function inside] = selectedTrackDetails

  async [types.TrackGenre.DELETE.SINGLE]({ getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { item, track_id } = payload;
    const { genre_relation_id } = item;

    NavTabHelper.updateSingleNavTabDetails(track_id, (trackObj) => {
      return {
        track_genres: trackObj.track_genres.
          filter(e => e.genre_relation_id != genre_relation_id)
      }
    });

    await TracksService.removeGenre(genre_relation_id);
  },

  async [types.TrackExternalIds.SET.ALL]({ getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { external_ids, item } = payload;
    const { track } = item;
    const { track_id } = track;

    NavTabHelper.updateSingleNavTabDetails(track_id, (trackObj) => {
      // console.log('trackObj ', trackObj);
      return {
        external_ids
      }
    });
  },

  async [types.TrackExternalIds.UPDATE.SINGLE]({ getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { name, value, item, selectedTrackDetails } = payload;
    const { track } = selectedTrackDetails;
    const { track_id } = track;

    const key = 'relation_id';
    const kVal = item[key];
    const table = 'l_relations';

    NavTabHelper.updateSingleNavTabDetails(track_id, (trackObj) => { // trackObj --> getters.trackDetails
      // console.log('trackObj ', trackObj);
      return {
        external_ids: trackObj.external_ids.map(e => {
          if (e.relation_id == item.relation_id) {
            return {
              ...e,
              [name]: value,
            };
          } else {
            return e;
          }
        })
      }
    });

    const modifiedTrack = await MHTTPCL.modifyJSON(undefined, kVal, name, value, table);
  },

  async [types.TrackExternalIds.DELETE.SINGLE]({ getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { item, track_id } = payload;
    const { relation_id } = item;

    NavTabHelper.updateSingleNavTabDetails(track_id, (trackObj) => {
      return {
        external_ids: trackObj.external_ids.
          filter(e => e.relation_id != relation_id)
      }
    });

    await TracksService.removeExternalIds(relation_id);
  },

  async [types.TrackManualMatches.DELETE.SINGLE]({ getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { item, track_id } = payload;
    const { relation_id } = item;

    NavTabHelper.updateSingleNavTabDetails(track_id, (trackObj) => {
      return {
        manual_matches: trackObj.manual_matches.
          filter(e => e.relation_id != relation_id)
      }
    });

    await TracksService.removeManualMatches(relation_id);
  },

  // Action of Updating single Object -- Related Products
  async [types.TrackRelatedProducts.UPDATE.SINGLE]({ getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { name, value, item, selectedTrackDetails } = payload;
    const { track } = selectedTrackDetails;
    const { track_id } = track;

    const key = 'product_track_id';
    const kVal = item[key];
    const table = 'l_product_tracks';

    NavTabHelper.updateSingleNavTabDetails(track_id, (trackObj) => { // trackObj --> getters.trackDetails
      // console.log('trackObj ', trackObj);
      return {
        products: trackObj.products.map(e => {
          if (e.product_track_id == item.product_track_id) {
            return {
              ...e,
              [name]: value,
            };
          } else {
            return e;
          }
        })
      }
    });

    const modifiedTrack = await MHTTPCL.modifyJSON(undefined, kVal, name, value, table);
  },

  // Deleted Track List
  async [types.TrackList.DELETE.SINGLE]({ commit, getters }, item) {
    const { track_id } = item;

    // console.log('Show getters data ', getters.trackList.tracks);
    let newTrackList = getters.trackList.tracks.filter(
      e => e.track_id != track_id
    );

    commit(types.TrackList.SET.ALL, {
      ...getters.trackList,
      tracks: newTrackList
    });

    const removeTrackList = await TracksService.removeTrackList(track_id);
  },

  async [types.MetaData.UPDATE.SINGLE]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters)

    const { name, value, item, kVal } = payload;
    const { track_id } = item

    const trackObj = getters.trackDetails[track_id];

    // console.log({ trackOB: trackObj });
    const table = 'metadata';

    NavTabHelper.updateSingleNavTabDetails(track_id, (trackObj) => {
      return {
        pricelists: trackObj.all_item_metadata.map(e => {
          if (e.metadata_id == kVal) {
            return {
              ...e,
              [name]: value,
            };
          } else {
            return e;
          }
        })
      }
    });

    const updatedPriceRes = await MHTTPCL.modifyJSON(
      undefined,
      kVal,
      name,
      value,
      table,
    );
  },
}